import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
export const store = configureStore({
    reducer: {
        auth: authReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ['auth/setUser'],
            ignoredActionPaths: ['payload.timestamp'],
            ignoredPaths: ['auth.user.lastActivity'],
        },
    }),
    devTools: process.env.NODE_ENV !== 'production',
});
